import type { ReactNode } from "react";
import "./state-message.css";

type Props = {
  tone: "loading" | "empty" | "error";
  title: string;
  children?: ReactNode;
  action?: { label: string; onSelect: () => void };
};

/** The one way a page says it is loading, has nothing to show, or has failed. */
export function StateMessage({ tone, title, children, action }: Props) {
  return (
    <div
      className="state-message"
      data-tone={tone}
      role={tone === "error" ? "alert" : "status"}
      aria-busy={tone === "loading"}
    >
      {tone === "loading" ? <span className="state-message__pulse" aria-hidden="true" /> : null}
      <p className="state-message__title">{title}</p>
      {children ? <p className="state-message__detail">{children}</p> : null}
      {action ? (
        <button type="button" className="state-message__action" onClick={action.onSelect}>
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
